import React, { createContext, useContext, useState, useCallback } from 'react';

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState('');
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => { });
  const [onCancel, setOnCancel] = useState(() => () => { });

  const showConfirmation = useCallback((msg, confirmFn, cancelFn = () => { }) => {
    setMessage(msg);
    setOnConfirm(() => confirmFn);
    setOnCancel(() => cancelFn);
    setIsConfirmationModal(true);
    setShowModal(true);
  }, []);

  const showInfo = useCallback((msg, duration = 2000) => {
    setMessage(msg);
    setIsConfirmationModal(false);
    setShowModal(true);
    setTimeout(() => setShowModal(false), duration);
  }, []);

  const hideModal = () => setShowModal(false);

  return (
    <ModalContext.Provider value={{
      showModal,
      message,
      showButtons: isConfirmationModal,
      isDeleting,
      setIsDeleting,
      onConfirm,
      onCancel,
      showConfirmation,
      showInfo,
      hideModal,
    }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModalFeedback() {
  return useContext(ModalContext);
}
